import PropTypes from "prop-types";
import { Label, Message } from "semantic-ui-react";
import TrackingRowsTable from "./tracking-rows-table";

// Preview for the multi-client tracking import (S3DEV2-7448). Unlike the per-company tracking preview
// (company-profile/preview-import/tracking-preview.jsx), the vendor path returns groups that have already
// been resolved to an order match across the selected company scope, so each group carries a match status
// (Found / NotFound / Ambiguous) and, when matched, the owning client company. Rows that could not be read
// come back as translation errors and are shown separately so nothing is silently dropped.
const statusColor = (status) => {
  switch (status) {
    case "Found":
      return "green";
    case "Ambiguous":
      return "yellow";
    default:
      return "red";
  }
};

const MultiClientTrackingPreview = ({ data }) => {
  const groups = data?.result?.groups ?? [];
  const errors = data?.result?.errors ?? [];

  const foundCount = groups.filter((g) => g.match_status === "Found").length;
  const notFoundCount = groups.filter((g) => g.match_status === "NotFound").length;
  const ambiguousCount = groups.filter((g) => g.match_status === "Ambiguous").length;

  return (
    <div>
      <h2 style={{ color: "#3498db" }}>Tracking Import Preview</h2>
      <div style={{ marginBottom: 15 }}>
        <Label color="green">Found: {foundCount}</Label>
        <Label color="red">Not Found: {notFoundCount}</Label>
        <Label color="yellow">Ambiguous: {ambiguousCount}</Label>
        {errors.length > 0 && <Label color="grey">Unreadable Rows: {errors.length}</Label>}
      </div>

      {errors.length > 0 && (
        <Message warning>
          <Message.Header>Rows that could not be read ({errors.length})</Message.Header>
          <Message.List>
            {errors.map((e, index) => (
              <Message.Item key={index}>
                Row {e.row_number}: {e.message}
              </Message.Item>
            ))}
          </Message.List>
        </Message>
      )}

      {groups.map((group, groupIndex) => (
        <div key={`${group.identifier}-${groupIndex}`} style={{ padding: 10 }}>
          <h5 style={{ marginBottom: 5 }}>
            {group.identifier}{" "}
            <Label size="small" color={statusColor(group.match_status)}>
              {group.match_status}
            </Label>
            {group.company_name && (
              <span style={{ marginLeft: 10, fontWeight: "normal" }}>
                → {group.company_name}
              </span>
            )}
          </h5>
          <TrackingRowsTable rows={group.rows} />
        </div>
      ))}
    </div>
  );
};

MultiClientTrackingPreview.propTypes = {
  data: PropTypes.shape({
    result: PropTypes.shape({
      groups: PropTypes.arrayOf(PropTypes.object),
      errors: PropTypes.arrayOf(PropTypes.object),
    }),
  }),
};

export default MultiClientTrackingPreview;
